import { ApiBulkSession } from '@agunity/api-v4';
import { Divider, Grid } from '@mui/material';
import { useIntl } from 'react-intl';

import { AgColor } from '../../../stories/Styles/AgColor';
import AgTypography from '../../../stories/Styles/AgTypography';
import CountTable from './CountTable';

const Count = ({ details }: { details: ApiBulkSession }) => {
  const { formatMessage } = useIntl();

  const hasData = (details?.memberCount || 0) > 0 || (details?.staffCount || 0) > 0 || (details?.orgCount || 0) > 0;

  if (!hasData) return null;

  return (
    <>
      <Grid item xs={12}>
        <AgTypography
          contentStyle='AP.H5.UPPERCASE.Bold'
          message={formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT' })}
          style={{ color: AgColor.grey6 }}
        />
      </Grid>

      <Grid item xs={12}>
        <AgTypography
          contentStyle='AP.Paragraph.Small.Regular'
          message={formatMessage({ id: 'BULK_UPLOAD_REQUEST_COUNT_DESC' })}
          style={{ color: AgColor.grey7 }}
        />
      </Grid>

      <Grid item xs={12}>
        <CountTable details={details} />
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
};

export default Count;